<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-card>
          <form-base
            :submit-status="submitStatus"
            action="Create"
            :errors="errors"
            :loading="loading"
            v-on:handleSubmit="handleSubmit"
            title="Create a lease"
          >
            <template v-slot:fields>
              <form-group label="Property" :required="true">
                <b-form-select
                  @blur="$v.lease.property_id.$touch"
                  :class="{ 'is-invalid': $v.lease.property_id.$error }"
                  v-model="lease.property_id"
                  :options="properties"
                  text-field="title"
                  value-field="id"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.lease.invoice_frequency.required"
                >
                  Please select Property
                </div>
              </form-group>

              <form-group label="Tenant" :required="true">
                <b-form-select
                  @blur="$v.lease.tenant_id.$touch"
                  :class="{ 'is-invalid': $v.lease.tenant_id.$error }"
                  v-model="lease.tenant_id"
                  :options="tenants"
                  text-field="name"
                  value-field="id"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.lease.tenant_id.required"
                >
                  Please select Tenant
                </div>
              </form-group>


               <form-group label="Type">
      <b-form-radio v-model="lease.type"  name="some-radios" value="fixed">Fixed Term</b-form-radio>
      <b-form-radio v-model="lease.type"  name="some-radios" value="month to month">Month to Month</b-form-radio>
    </form-group>


              <form-group label="Auto Invoice">
                <b-form-checkbox
                  v-model="lease.auto_generate"
                  value="1"
                  switch
                  unchecked-value="0"
                >
                  Auto generate invoice
                </b-form-checkbox>
              </form-group>

              <form-group
                label="Invoice Frequency"
                v-if="lease.auto_generate == 1"
                :required="true"
              >
                <b-form-select
                  @blur="$v.lease.invoice_frequency.$touch"
                  :class="{ 'is-invalid': $v.lease.invoice_frequency.$error }"
                  v-model="lease.invoice_frequency"
                >
                  <b-form-select-option value="Daily"
                    >Daily</b-form-select-option
                  >
                  <b-form-select-option value="Weekly"
                    >Weekly</b-form-select-option
                  >
                  <b-form-select-option value="Monthly"
                    >Monthly</b-form-select-option
                  >
                </b-form-select>
                <div
                  class="invalid-feedback"
                  v-if="!$v.lease.invoice_frequency.required"
                >
                  Please select invoice frequency
                </div>
              </form-group>

              <form-group
                label="Invoice Amount"
                v-if="lease.auto_generate == 1"
                :required="true"
              >
                <input
                  class="form-control"
                  type="number"
                  @blur="$v.lease.invoice_amount.$touch"
                  :class="{ 'is-invalid': $v.lease.invoice_amount.$error }"
                  v-model="lease.invoice_amount"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.lease.invoice_amount.required"
                >
                  Please select invoice amount
                </div>
              </form-group>

               <form-group label="Invoice Description" :required="true"   v-if="lease.auto_generate == 1">
                <input
                  :class="{
                    'is-invalid': $v.lease.invoice_description.$error,
                  }"
                  v-model="lease.invoice_description"
                  class="mb-2 form-control"
                />
                <div
                  class="invalid-feedback"
                  v-if="$v.lease.invoice_description.required"
                >
                  Please select invoice description
                </div>
              </form-group>

              <form-group
                label="Invoice Day"
                v-if="
                  lease.auto_generate == 1 && lease.invoice_frequency != 'Daily'
                "
                :required="true"
              >
                <small>1 = Monday, if weekly frequency</small>
                <b-form-select
                  @blur="$v.lease.invoice_day.$touch"
                  :class="{ 'is-invalid': $v.lease.invoice_day.$error }"
                  v-model="lease.invoice_day"
                >
                  <b-form-select-option value="1">1</b-form-select-option>
                  <b-form-select-option value="2">2</b-form-select-option>
                  <b-form-select-option value="3">3</b-form-select-option>
                  <b-form-select-option value="4">4</b-form-select-option>
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="6">6</b-form-select-option>
                  <b-form-select-option value="7">7</b-form-select-option>
                  <b-form-select-option
                    value="8"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >8</b-form-select-option
                  >
                  <b-form-select-option
                    value="9"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >9</b-form-select-option
                  >
                  <b-form-select-option
                    value="10"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >10</b-form-select-option
                  >
                  <b-form-select-option
                    value="11"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >11</b-form-select-option
                  >
                  <b-form-select-option
                    value="12"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >12</b-form-select-option
                  >
                  <b-form-select-option
                    value="13"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >13</b-form-select-option
                  >
                  <b-form-select-option
                    value="14"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >14</b-form-select-option
                  >
                  <b-form-select-option
                    value="15"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >15</b-form-select-option
                  >
                  <b-form-select-option
                    value="16"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >16</b-form-select-option
                  >
                  <b-form-select-option
                    value="17"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >17</b-form-select-option
                  >
                  <b-form-select-option
                    value="18"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >18</b-form-select-option
                  >
                  <b-form-select-option
                    value="19"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >19</b-form-select-option
                  >
                  <b-form-select-option
                    value="20"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >20</b-form-select-option
                  >
                  <b-form-select-option
                    value="21"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >21</b-form-select-option
                  >
                  <b-form-select-option
                    value="22"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >22</b-form-select-option
                  >
                  <b-form-select-option
                    value="23"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >23</b-form-select-option
                  >
                  <b-form-select-option
                    value="24"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >24</b-form-select-option
                  >
                  <b-form-select-option
                    value="25"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >25</b-form-select-option
                  >
                  <b-form-select-option
                    value="26"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >26</b-form-select-option
                  >
                  <b-form-select-option
                    value="27"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >27</b-form-select-option
                  >
                  <b-form-select-option
                    value="28"
                    v-if="lease.invoice_frequency == 'Monthly'"
                    >28</b-form-select-option
                  >
                </b-form-select>
                <div
                  class="invalid-feedback"
                  v-if="!$v.lease.invoice_day.required"
                >
                  Please select invoice day
                </div>
              </form-group>


               <form-group label="Auto Email" v-if="lease.auto_generate == 1">
                <b-form-checkbox
                  v-model="lease.auto_email"
                  value="1"
                  switch
                  unchecked-value="0"
                >
                  Auto email invoice to tenant 
                </b-form-checkbox>
              </form-group>

              <!-- <form-group label="Auto SMS"  v-if="lease.auto_generate == 1">
                <b-form-checkbox
                  v-model="lease.auto_sms"
                  value="1"
                  switch
                  unchecked-value="0"
                >
                  Auto sms invoice to tenant
                </b-form-checkbox>
              </form-group> -->

              <form-group label="From" :required="true">
                <b-form-datepicker
                  :class="{
                    'is-invalid': $v.lease.from.$error,
                  }"
                  v-model="lease.from"
                  class="mb-2"
                ></b-form-datepicker>
                <div class="invalid-feedback" v-if="$v.lease.from.required">
                  Please select date from
                </div>
              </form-group>

              <form-group label="To" :required="true" v-if="lease.type=='fixed'">
                <b-form-datepicker
                  :class="{
                    'is-invalid': $v.lease.to.$error,
                  }"
                  v-model="lease.to"
                  class="mb-2"
                ></b-form-datepicker>
                <div class="invalid-feedback" v-if="$v.lease.to.required">
                  Please select date to
                </div>
              </form-group>

             

              <form-group label="Deposit Amount">
                <input
                  type="number"
                  v-model="lease.deposit_amount"
                  class="mb-2 form-control"
                />
              </form-group>
            </template>
          </form-base>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import leaseRepo from "@/api/repos/propertyLeaseRepo";
import { required, requiredIf } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    lease: {
      property_id: {
        required,
      },
      tenant_id: {
        required,
      },
      to: {
        required: requiredIf(function (lease) {
          return lease.type == 'fixed' ? true : false;
        }),
      },
      from: {
        required,
      },
      invoice_frequency: {
        required: requiredIf(function (lease) {
          return lease.auto_generate == 1 ? true : false;
        }),
      },
      invoice_description: {
         required: requiredIf(function (lease) {
          return lease.auto_generate == 1 ? true : false;
        }),
      },
      invoice_day: {
         required: requiredIf(function (lease) {
          return lease.auto_generate == 1 && lease.invoice_frequency != 'Daily' ? true : false;
        }),
      },
      invoice_amount: {
         required: requiredIf(function (lease) {
          return lease.auto_generate == 1 ? true : false;
        }),
      },
    },
  },

  mounted() {
    this.getCreatedData();
  },

  data() {
    return {
      properties: [],
      tenants: [],
      lease: {
        type:'fixed',
        auto_generate:0,
        auto_email:1,
        auto_sms:0
      },

      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getCreatedData() {
      try {
        this.loading = true;
        let { data } = await leaseRepo.createRelatedData();
        this.tenants = data.tenants;
        this.tenants.forEach((x) => {
          x.name = x.name + " - " + (x.id_number ? x.id_number : "");
        });
        this.properties = data.properties;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await leaseRepo.create(this.lease);
          this.$router.push({ name: "leases" });
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

<style></style>
